<template>
  <v-container fluid class="cont-pagina">
    <!-- <v-row class="no-gutters">
      <v-col cols="12">
        <h3 class="titulo-contendor text-center py-3">Elementos extraviados</h3>
      </v-col>
    </v-row> -->
    <v-row class="no-gutters">
      <v-col cols="12" class="px-2 mb-4">
        <v-btn
          v-if="bValidarInternet"
          block
          color="primary"
          @click="onPaginaBusqueda"
          elevation="2"
        ><v-icon class="mr-2">mdi-magnify</v-icon>Buscar elementos</v-btn>
      </v-col>
      <v-col>
        <Form 
        :bInternet="true"
        :idMovilApp="34"
        titulo="Elementos extraviados"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import mxFuncionesBasicas from "@/mixins/FuncionesBasicas.js";
// import { mapGetters } from 'vuex';
import Form from "@/components/Form/Form.vue";

export default {
  name: 'inicioElementoExtraviado',
  mixins: [mxFuncionesBasicas],
  components:{
    Form
  },
  data() {
    return {
      bValidarInternet:true
    }
  },
  methods: {
    onPaginaBusqueda(){
      this.$router.push('/PWA/elementosextraviados/busquedaElementosExtraviados')
    },
    updateOnlineStatus() {
      this.bValidarInternet = navigator.onLine
    }
  },
  mounted() {
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
  },
  computed: {
  }
}
</script>
<style lang="scss">
tbody{
  tr{
    td{
      font-size: 11px!important;
      min-height: 30px!important;
    }
  }
}
.v-icon.v-icon{
  font-size: 18px;
}
.boton-mas{
  color: blue;
}
.cont-item-pag{
  transform: scale(0.8);
}
.text-registros{
  font-size:12px;
  text-align: left;
}
</style>